import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faMoneyBill,
  faDraftingCompass,
  faUserSecret,
} from "@fortawesome/free-solid-svg-icons";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

const StatusIcons = ({ payed, draft, subscription, privateButton }) => {
  const draftTip = (
    <Tooltip id="draft">
      <strong>Draft</strong>
    </Tooltip>
  );
  const payedTip = (
    <Tooltip id="draft">
      <strong>Payed</strong>
    </Tooltip>
  );

  const notPayedTip = (
    <Tooltip id="draft">
      <strong>Not Payed</strong>
    </Tooltip>
  );

  const privateTip = (
    <Tooltip id="draft">
      <strong>Private</strong>
    </Tooltip>
  );

  const subscriptionTip = (
    <Tooltip id="draft">
      <strong>This is a subscription</strong>
    </Tooltip>
  );

  const pill = (bg, color, icon) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "26px",
    height: "26px",
    borderRadius: "8px",
    background: bg,
    color: color,
    fontSize: "0.75rem",
    marginRight: "4px",
    boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
  });

  const PayedButton = (payed) => (
    <>
      {payed.payed === true ? (
        <OverlayTrigger placement="left" overlay={payedTip}>
          <span style={pill("#e8f5e9", "#2e7d32")}>
            <FontAwesomeIcon icon={faMoneyBill} />
          </span>
        </OverlayTrigger>
      ) : (
        <OverlayTrigger placement="left" overlay={notPayedTip}>
          <span style={pill("#ffebee", "#c62828")}>
            <FontAwesomeIcon icon={faMoneyBill} />
          </span>
        </OverlayTrigger>
      )}
    </>
  );

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
      {typeof payed !== "undefined" && draft !== true ? (
        <PayedButton payed={payed} />
      ) : null}
      {draft ? (
        <OverlayTrigger placement="left" overlay={draftTip}>
          <span style={pill("#fff8e1", "#f57c00")}>
            <FontAwesomeIcon icon={faDraftingCompass} />
          </span>
        </OverlayTrigger>
      ) : null}
      {subscription === true ? (
        <OverlayTrigger placement="left" overlay={subscriptionTip}>
          <span style={pill("#e3f2fd", "#1565c0")}>
            <FontAwesomeIcon icon={faClock} />
          </span>
        </OverlayTrigger>
      ) : null}
      {privateButton === true ? (
        <OverlayTrigger placement="left" overlay={privateTip}>
          <span style={pill("#f3e5f5", "#6a1b9a")}>
            <FontAwesomeIcon icon={faUserSecret} />
          </span>
        </OverlayTrigger>
      ) : null}
    </div>
  );
};

export default StatusIcons;
